import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import searchMixin from '@/mixin/search';
import SearchBar from '@/views/task/components/search.vue';
import Pagination from '@/components/Pagination/index.vue';
import TaskTable from '@/views/task/components/table.vue';
import PreviewModal from '@/components/PreviewModal/index.vue';
import taskDetail from '@/views/task/components/taskDetail.vue';
import DialogForm from '@/components/DialogForm/index.vue';
import ConfirmBtn from '@/components/ConfirmBtn/index.vue';
import { fetchTaskAllList, fetchTaskList, changeAudit, submitToTestTask, updateMyTestZip, cancelTestTask, passAdvAudit, changeTaskStatus, updateMyTestPerson, publishTask, rollbackTask, hideShowGuessLike } from '@/api/qa/task';
import { parseTraffic } from '@/filters';
import { createPSProject } from '@/api/ps/manage';
import { taskSearchField } from '@/common/material-metadata';

var query = {
  keyword: '', // 关键字
  // app_cat_ids: [], // app分类
  category_ids: [], // 素材类别
  statuses: [], // 任务状态
  platforms: [], // 平台
  traffic_types: [], // 渠道
  languages: [], // 语言
  demander_ids: [], // 提需人
  planner_ids: [], // 策划师
  account_manager_ids: [], // am
  designer_ids: [], // 设计师
  developer_ids: [], // 研发
  adv_ids: [], // 广告主
  tester_ids: [], // 测试
  tag_ids: [], // 标签
  time: [], // 时间，0 为起始时间，1 为结束时间
  search_time: 'created_time',
  page: 1,
  page_size: 15,
  material_source: '', // 素材来源
  provider_ids: [] // 素材供应商
};

export default {
  name: 'TaskList',

  components: {
    SearchBar: SearchBar,
    TaskTable: TaskTable,
    Pagination: Pagination,
    PreviewModal: PreviewModal,
    taskDetail: taskDetail,
    DialogForm: DialogForm,
    ConfirmBtn: ConfirmBtn
  },

  mixins: [searchMixin],

  props: {
    readonly: {
      type: Boolean,
      default: true
    },
    isTemplatePreview: {
      type: Boolean,
      default: false
    },
    searchFieldName: {
      // 通过参数searchFieldName指定ID搜索类型，默认为id，即测试任务ID
      type: String,
      default: 'id'
    }
  },

  data: function data(props) {
    var defaultQuery = _extends({
      search_field: props.searchFieldName }, query);
    return {
      pagination: {
        total: 0
      },

      query: _.pick(defaultQuery, ['search_field', // 搜索类型
      'keyword', // 关键字
      // 'app_cat_ids', // app分类
      'category_ids', // 素材类别
      'statuses', // 任务状态
      'platforms', // 平台
      'traffic_types', // 渠道
      'languages', // 语言
      'demander_ids', // 提需人
      'account_manager_ids', // am
      'planner_ids', // 策划师
      'designer_ids', // 设计师
      'developer_ids', // 研发
      'adv_ids', // 广告主
      'tester_ids', // 测试
      'tag_ids', // 标签
      'search_time', // 时间类型
      'time', // 时间
      'page', 'page_size', 'material_source', // 素材来源
      'provider_ids']),
      columnConfig: ['selection', 'action-cell', // 操作
      'demand_id', // 需求ID
      'demand_name', // 需求名称
      'id', // 测试任务ID
      'app_icon', // 图标
      'product-cell', // 产品信息
      'basic-cell', // 基础包信息
      'zip-info-cell', // zip属性
      'time-cell', // 时间点
      'staff-cell', // staff
      'status-cell', // test status
      'audit-cell', // advertiser audit
      'tag-cell'],
      taskList: [],
      batchTask: [],
      listLoading: true,
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        html_url_cdn: '',
        orientation: '',
        language: '',
        id: '',
        traffic_type: ''
      },
      detail: {
        id: '',
        visible: false
      },
      dialog: {
        type: 0, // 1: 提测，2：更新，3：修改状态，4：调整人员
        uploaderVisible: false, // a uploader reset visible flag
        config: {
          title: '',
          visible: false,
          loading: false
        },
        formConfig: {
          labelPosition: 'left',
          labelWidth: '120px'
        },
        value: {
          id: '',
          developer_uid: '',
          tester_uid: '',
          app_name: '',
          demand_name: '',
          comment: '',
          zip_file: '',
          is_compress: '',
          traffic_type: '',
          traffic_text: '',
          category_id: '',
          status: '',
          reason: '',
          language: '',
          material_source: 0
        }
      },
      // 当素材来源为ss时，才显示‘测试不通过’选项
      status_options: [{
        value: 7,
        label: '待测试',
        border: true
      }, {
        value: 1,
        label: '测试中',
        border: true
      }, {
        value: 2,
        label: '测试通过',
        border: true
      }],
      pushPSDialog: {
        config: {
          title: '推送ps项目测试',
          visible: false,
          loading: false
        },
        value: {
          name: '',
          adv_id: '',
          orientation: 3,
          source: 'gm',
          tpl_id: ''
        },
        itemList: [{
          label: '模板id：',
          type: 'plain-text',
          prop: 'tpl_id'
        }, {
          label: '推送至广告主：',
          prop: 'adv_id',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            filterable: true
          }
        }, {
          label: 'ps项目名：',
          type: 'input',
          prop: 'name',
          rules: [{
            required: true,
            trigger: 'blur',
            message: '作品名称不能为空'
          }, {
            validator: function validator(rule, value, callback) {
              var re = /^[0-9a-zA-Z_]{1,50}$/;
              if (re.test(value)) {
                callback();
              } else {
                callback(new Error('仅支持数字、字母、下划线，50个字符以内'));
              }
            },
            trigger: 'blur'
          }]
        }]
      }
    };
  },


  computed: {
    keyField: function keyField() {
      // 分配需求-任务管理页面外包权限仅限需求ID、测试任务ID筛选
      if (this.isTemplatePreview && this.hasPermission('data.outsourced_user')) {
        return taskSearchField.filter(function (s) {
          return s.value === 'demand_id' || s.value === 'id';
        });
      }

      return [];
    },
    formItems: function formItems() {
      var defaultQuery = _extends({
        search_field: this.searchFieldName }, query);
      var formItems = _Object$keys(_.pick(defaultQuery, ['search_field', // 搜索类型
      'keyword', // 关键字
      // 'app_cat_ids', // app分类
      'category_ids', // 素材类别
      'statuses', // 任务状态
      'platforms', // 平台
      'traffic_types', // 渠道
      'languages', // 语言
      'demander_ids', // 提需人
      'account_manager_ids', // am
      'planner_ids', // 策划师
      'designer_ids', // 设计师
      'developer_ids', // 研发
      'adv_ids', // 广告主
      'tester_ids', // 测试
      'tag_ids', // 标签
      'material_source', // 素材来源
      'provider_ids', // 素材供应商
      'search_time', // 时间类型
      'time'] // 时间
      ));

      // 分配需求-任务管理页面外包权限仅限需求ID、测试任务ID和日期筛选
      if (this.isTemplatePreview && this.hasPermission('data.outsourced_user')) {
        var newFormItems = formItems.filter(function (item) {
          return item === 'search_field' || item === 'keyword' || item === 'search_time' || item === 'time';
        });
        return newFormItems;
      }

      return formItems;
    },
    innerColumnConfig: function innerColumnConfig() {
      // 当不是readonly的时候才显示所有，readonly不允许出现复选框，当有qa.task.adv-audit权限时才允许显示selection
      if (!this.readonly && this.$store.getters.roles.indexOf('qa.task.adv-audit') !== -1) {
        return this.columnConfig;
      }
      return _.filter(this.columnConfig, function (item) {
        return item !== 'selection';
      });
    },
    dialogItemList: function dialogItemList() {
      var _this = this;

      return [{
        label: '任务ID：',
        type: 'plain-text',
        prop: 'id'
      }, {
        label: '需求名称：',
        type: 'plain-text',
        prop: 'demand_name'
      }, {
        label: '产品名称：',
        type: 'plain-text',
        prop: 'app_name'
      }, {
        label: '投放渠道：',
        type: 'plain-text',
        prop: 'traffic_text'
      }, {
        label: '投放语言：',
        type: 'plain-text',
        prop: 'language'
      }, {
        visible: function visible(_ref) {
          var formValue = _ref.formValue;

          return _this.dialog.type === 2 && Number(formValue.traffic_type) !== 1 && (Number(formValue.category_id) === 2 || Number(formValue.category_id) === 3);
        },
        label: '是否压缩：',
        type: 'radio-group',
        prop: 'is_compress',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return {
            disabled: false,
            options: [{
              value: 3,
              label: '自动',
              border: true
            }, {
              value: 0,
              label: '不压缩',
              border: true
            }],
            button: false,
            border: true
          };
        }
      }, {
        visible: this.dialog.type === 2 && this.dialog.uploaderVisible,
        label: 'Zip包：',
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'zip_file',
        rules: [{
          required: true,
          message: '请选择上传Zip包',
          trigger: 'blur'
        }],
        params: {
          disabled: false,
          drag: true,
          'with-credentials': true,
          accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
          tip: '只能上传zip文件',
          fileList: [],
          'on-remove': function onRemove(file, fileList) {
            _this.dialog.value.zip_file = '';
          }
        }
      }, {
        visible: this.dialog.type === 2,
        label: '修改说明：',
        type: 'input',
        subtype: 'textarea',
        prop: 'comment',
        rules: [{
          required: true,
          message: '请输入修改说明',
          trigger: 'blur'
        }]
      }, {
        visible: this.dialog.type === 3,
        label: '修改状态：',
        type: 'radio-group',
        prop: 'status',
        params: {
          options: this.status_options,
          button: false
        },
        rules: [{
          required: true,
          message: '请选择测试状态',
          trigger: 'blur'
        }]
      }, {
        visible: function visible(_ref3) {
          var formValue = _ref3.formValue;

          return _this.dialog.type === 3 && Number(formValue.status) === 15;
        },
        label: '不通过理由：',
        type: 'input',
        subtype: 'textarea',
        prop: 'comment_reason',
        rules: [{
          required: true,
          message: '请输入不通过理由',
          trigger: 'blur'
        }]
      }, {
        visible: this.dialog.type === 4,
        label: '选择研发人员：',
        type: 'business',
        subtype: 'developer-selector',
        prop: 'developer_uid',
        rules: [{
          required: true,
          message: '请选择研发人员',
          trigger: 'change'
        }]
      }, {
        visible: this.dialog.type === 1 || this.dialog.type === 4,
        label: '选择测试人员：',
        type: 'business',
        subtype: 'tester-selector',
        prop: 'tester_uid',
        rules: [{
          required: true,
          message: '请选择测试人员',
          trigger: 'change'
        }]
      }, {
        visible: this.dialog.type === 5,
        label: '撤回原因：',
        type: 'input',
        subtype: 'textarea',
        prop: 'reason',
        rules: [{
          required: true,
          message: '请输入撤回原因',
          trigger: 'blur'
        }]
      }];
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.getTaskList();
    },
    'dialog.config.visible': function dialogConfigVisible(val) {
      if (val) {
        this.dialog.uploaderVisible = true;
      } else {
        this.dialog.uploaderVisible = false;
        this.dialog.value.zip_file = '';
        this.$refs['dialog-form'].resetFields();
      }
    }
  },

  methods: {
    getTaskList: function getTaskList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.listLoading = true;

                _context.prev = 1;
                res = void 0;

                if (!_this2.readonly) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return fetchTaskAllList(params || _this2.query);

              case 6:
                res = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return fetchTaskList(params || _this2.query);

              case 11:
                res = _context.sent;

              case 12:
                _this2.taskList = _.get(res, 'data.data.list') || [];
                _this2.pagination.total = _.get(res, 'data.data.total');
                _this2.listLoading = false;
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                _this2.listLoading = false;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 17]]);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.batchTask = val;
    },
    previewPA: function previewPA(obj) {
      this.previewDialog = _extends({}, this.previewDialog, {
        visible: true,
        title: (obj.app_info || {}).name,
        html_url: obj.basic_preview_url,
        default_html_url: obj.html_url }, _.pick(obj, ['debug_html_url', 'html_url_cdn', 'orientation', 'id', 'language', 'category_id', 'traffic_type']), {
        // 只有FaceBook,Unity,Vungle,Applovin,IronSource渠道需要调试Url
        showDebugUrl: [3, 5, 6, 7, 10].indexOf(Number(obj.traffic_type)) !== -1 || false,
        setRows: function setRows(params) {
          _Object$assign(obj, params);
        }
      });
    },
    handleSeeMore: function handleSeeMore(obj) {
      this.detail.id = obj.id;
      this.detail.visible = true;
    },
    handleChangeAudit: function handleChangeAudit(obj) {
      var _this3 = this;

      changeAudit({
        id: obj.id,
        status: obj.advertiser_audit
      }).then(function (res) {
        _this3.$message({
          message: '切换成功',
          type: 'success'
        });
      }).catch(function () {
        _this3.getTaskList(_this3.query);
      });
    },

    // 展示操作dynamicDialog, type=1: 提测，2：更新，3：修改状态，4：调整人员，5：发布任务撤回
    showDialog: function showDialog(obj, type) {
      this.dialog.type = type;
      this.dialog.value.id = obj.id;
      this.dialog.value.app_name = obj.app_name;
      this.dialog.value.demand_name = (obj.demand_info || {}).name || '-';
      this.dialog.value.status = obj.status;
      this.dialog.value.traffic_text = parseTraffic(obj.traffic_type);
      this.dialog.value.language = obj.language;
      this.dialog.value.material_source = obj.material_source;
      switch (type) {
        case 1:
          this.dialog.config.title = '提测';
          this.dialog.value.tester_uid = '';
          break;
        case 2:
          this.dialog.config.title = '上传更新包';
          this.dialog.value.is_compress = 3;
          this.dialog.value.traffic_type = obj.traffic_type;
          this.dialog.value.category_id = obj.category_id;
          break;
        case 3:
          this.dialog.config.title = '修改提测状态';

          // 当素材来源为ss时，才显示‘测试不通过’选项
          for (var index in this.status_options) {
            if (this.status_options[index].value === 15) {
              this.status_options.splice(index, 1);
            }
          }
          if (this.dialog.value.material_source === 3) {
            this.status_options.push({
              value: 15,
              label: '测试不通过',
              border: true
            });
          }
          break;
        case 4:
          this.dialog.config.title = '调整人员';
          this.dialog.value.tester_uid = (obj.tester || {}).id || '';
          this.dialog.value.developer_uid = (obj.developer || {}).id || '';
          break;
        case 5:
          this.dialog.config.title = '已发布任务撤回';
          break;
        default:
          break;
      }
      this.dialog.config.visible = true;
    },
    submitDialogForm: function submitDialogForm() {
      this.dialog.config.loading = true;
      switch (this.dialog.type) {
        case 1:
          this.handleSubmitToTest();
          break;
        case 2:
          this.handleUpdateTast();
          break;
        case 3:
          this.handleChangeStatus();
          break;
        case 4:
          this.handleChangeStaff();
          break;
        case 5:
          this.handlePublishRollback();
          break;
        default:
          break;
      }
    },
    handleSubmitToTest: function handleSubmitToTest() {
      var _this4 = this;

      submitToTestTask(_.pick(this.dialog.value, ['id', 'tester_uid'])).then(function () {
        _this4.$message({
          message: '提测成功',
          type: 'success'
        });
        _this4.dialog.config.loading = false;
        _this4.dialog.config.visible = false;
        _this4.getTaskList();
      }).catch(function (error) {
        var errorMsg = _.get(error, 'data.msg');
        _this4.$alert(errorMsg, '错误提示', {
          type: 'error',
          customClass: 'basic-package-error-message',
          dangerouslyUseHTMLString: true
        });
        _this4.dialog.config.loading = false;
      });
    },
    handlePublishRollback: function handlePublishRollback() {
      var _this5 = this;

      var data = _.pick(this.dialog.value, ['id', 'reason']);
      rollbackTask(data).then(function (res) {
        _this5.$message({
          message: '撤回成功',
          type: 'success'
        });
        _this5.dialog.config.loading = false;
        _this5.dialog.config.visible = false;
        _this5.getTaskList();
      }).catch(function () {
        _this5.dialog.config.loading = false;
      });
    },
    handleUpdateTast: function handleUpdateTast() {
      var _this6 = this;

      var data = _.pick(this.dialog.value, ['id', 'comment', 'zip_file', 'is_compress']);
      updateMyTestZip(data).then(function () {
        _this6.$message({
          message: '更新成功',
          type: 'success'
        });
        _this6.dialog.config.loading = false;
        _this6.dialog.config.visible = false;
        _this6.getTaskList();
      }).catch(function (error) {
        var errorMsg = _.get(error, 'data.msg');
        _this6.$alert(errorMsg, '错误提示', {
          type: 'error',
          customClass: 'basic-package-error-message',
          dangerouslyUseHTMLString: true
        });
        _this6.dialog.config.loading = false;
      });
    },
    handleChangeStatus: function handleChangeStatus() {
      var _this7 = this;

      var data = _.pick(this.dialog.value, ['id', 'status']);
      // 修改状态为测试不通过时，需要填写不通过理由
      if (this.dialog.value.comment_reason && Number(this.dialog.value.status) === 15) {
        data.comment = this.dialog.value.comment_reason;
      }
      changeTaskStatus(data).then(function () {
        _this7.$message({
          message: '修改成功',
          type: 'success'
        });
        _this7.dialog.config.loading = false;
        _this7.dialog.config.visible = false;
        _this7.getTaskList();
      }).catch(function () {
        _this7.dialog.config.loading = false;
      });
    },
    handleChangeStaff: function handleChangeStaff() {
      var _this8 = this;

      var data = _.pick(this.dialog.value, ['id', 'developer_uid', 'tester_uid']);
      updateMyTestPerson(data).then(function () {
        _this8.$message({
          message: '调整人员成功',
          type: 'success'
        });
        _this8.dialog.config.loading = false;
        _this8.dialog.config.visible = false;
        _this8.getTaskList();
      }).catch(function () {
        _this8.dialog.config.loading = false;
      });
    },
    handleDelete: function handleDelete(obj) {
      var _this9 = this;

      this.listLoading = true;
      cancelTestTask({
        id: obj.id
      }).then(function (res) {
        _this9.$message({
          message: '删除成功',
          type: 'success'
        });
        _this9.getTaskList();
      }).catch(function () {
        _this9.listLoading = false;
      });
    },
    handleAudit: function handleAudit(obj) {
      this.passAuditTask(obj.id);
    },
    passAuditTask: function passAuditTask(ids) {
      var _this10 = this;

      this.listLoading = true;
      passAdvAudit({
        ids: ids,
        status: 2
      }).then(function (res) {
        _this10.listLoading = false;
        _this10.$message({
          message: '操作成功',
          type: 'success'
        });
        _this10.getTaskList();
      }).catch(function () {
        _this10.listLoading = false;
      });
    },
    batchPassTask: function batchPassTask() {
      var ids = this.batchTask.map(function (e) {
        return e.id;
      }).join();
      this.passAuditTask(ids);
    },
    handleSortChange: function handleSortChange(_ref4) {
      var column = _ref4.column,
          prop = _ref4.prop,
          order = _ref4.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    handlePublish: function handlePublish(obj) {
      var _this11 = this;

      this.listLoading = true;
      publishTask({
        id: obj.id
      }).then(function (res) {
        _this11.$message({
          message: '发布成功',
          type: 'success'
        });
        _this11.getTaskList();
      }).catch(function (error) {
        var errorMsg = _.get(error, 'data.msg');
        _this11.$alert(errorMsg, '错误提示', {
          type: 'error',
          customClass: 'basic-package-error-message',
          dangerouslyUseHTMLString: true
        });
        _this11.listLoading = false;
      });
    },
    handleRollback: function handleRollback(obj) {
      var _this12 = this;

      this.listLoading = true;
      rollbackTask({
        id: obj.id
      }).then(function (res) {
        _this12.$message({
          message: '撤回成功',
          type: 'success'
        });
        _this12.getTaskList();
      }).catch(function () {
        _this12.listLoading = false;
      });
    },
    hadAudited: function hadAudited(status) {
      return [7, 1, 2, 3].indexOf(Number(status)) !== -1;
    },
    getGuessLikeText: function getGuessLikeText(row) {
      var text = '折叠猜你喜欢';
      var config = {};
      if (row.extra_config) {
        try {
          config = JSON.parse(row.extra_config);
        } catch (error) {
          console.warn('extra_config的内容无法做json解析');
        }
        if (Number(config.hide_guess_like) === 1) {
          text = '展示猜你喜欢';
        }
      }
      return text;
    },
    changeGuessLikeStatus: function changeGuessLikeStatus(obj) {
      var _this13 = this;

      this.listLoading = true;
      var config = {};
      if (obj.extra_config) {
        try {
          config = JSON.parse(obj.extra_config);
        } catch (error) {
          console.warn('extra_config的内容无法做json解析');
        }
      }
      hideShowGuessLike({
        id: obj.id,
        hide_guess_like: Number(config.hide_guess_like) === 1 ? 0 : 1
      }).then(function (res) {
        _this13.$message({
          message: '操作成功',
          type: 'success'
        });
        _this13.getTaskList();
      }).catch(function () {
        _this13.listLoading = false;
      });
    },
    navigateToTemplatePreviewPage: function navigateToTemplatePreviewPage(_ref5) {
      var basic_id = _ref5.basic_id,
          demand_info = _ref5.demand_info;

      this.$router.push({
        name: 'creative.template',
        params: {
          templateId: demand_info.creative_id
        },
        query: {
          preview: 1,
          basic_id: basic_id
        }
      });
    },
    navigateToTemplatePreviewPageByGmTplId: function navigateToTemplatePreviewPageByGmTplId(_ref6) {
      var _this14 = this;

      var basic_id = _ref6.basic_id,
          demand_info = _ref6.demand_info;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this14.$router.push({
                  name: 'creative.template',
                  params: {
                    templateId: demand_info.ext_gm_template_id
                  },
                  query: {
                    preview: 1,
                    basic_id: basic_id,
                    tpl_type: 'gm' // gm 模板
                  }
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this14);
      }))();
    },
    handlePushPSProject: function handlePushPSProject(row) {
      console.log('handlePushPSProject', row);
      var temp = {
        tpl_id: row.demand_info.ext_gm_template_id
      };
      this.pushPSDialog.config.visible = true;
      this.pushPSDialog.value = _Object$assign({}, this.pushPSDialog.value, temp);
    },
    submitPushPSDialogForm: function submitPushPSDialogForm() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this15.pushPSDialog.config.loading = true;
                data = _this15.pushPSDialog.value;
                _context3.prev = 2;
                _context3.next = 5;
                return createPSProject(data);

              case 5:
                res = _context3.sent;

                if (res.data.code === 0) {
                  _this15.$message({
                    message: '创建成功',
                    type: 'success'
                  });
                  _this15.pushPSDialog.config.loading = false;
                  _this15.pushPSDialog.config.visible = false;
                  _this15.getTaskList();
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);

                console.log('error', _context3.t0);

              case 12:
                _context3.prev = 12;

                _this15.pushPSDialog.config.loading = false;
                return _context3.finish(12);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this15, [[2, 9, 12, 15]]);
      }))();
    }
  },

  mounted: function mounted() {
    this.getTaskList();
  }
};